import React from 'react';
import './Catalogo.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import {actions as actionsSite} from './../../redux/actions/site';
const Catalogo = props => {

    const { nome, descricao, validade, imagemCapa, pdf } = props.data;
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth.profile);

    const shareWhats = _ => {
        const url = `https://wa.me/?text=Você já viu o Catálogo que estou revendendo? São produtos de excelente qualidade e preços incríveis. Confira e fale comigo! https://www.lekacatalogos.com.br`;
        window.open(url,'_blank');
    }

    const downloadPdf = _ => {
        if(profile._id){
            window.open(pdf,'_blank');
        } else {
            dispatch(actionsSite.setLoadingMsg({msg:"Para baixar o catálogo é preciso ter um cadastro", action:{goto:'/cadastro'}}));
        }
    }

    return (
        <div className='catalogo'>
            <img src={imagemCapa} alt="catalogo" />
            <div className="info">
                <div className="title">{nome}</div>
                <div className="texts">
                    <span className="descricao">{descricao}</span>
                    <span className="validade"><strong>Validade:</strong> {validade}</span>
                    <div className="acoes">
                        <button className="download" onClick={downloadPdf}>
                            <FontAwesomeIcon icon={faDownload} /> Baixar catálogo
                        </button>
                        <button className="whatsapp" onClick={shareWhats}>
                            <FontAwesomeIcon icon={faWhatsapp} /> Compartilhar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Catalogo;